<form [formGroup]="form | bgoAsFormGroup" *transloco="let t">
  <div>
    <div class="space-y-md">
      <label class="mt-xs font-bold">{{ t('createJobRequest.lawnMowing.sizeOfArea.label') }}</label>
      <cft-number-input
        [formControl]="form.controls.sizeOfArea | bgoAsFormControl"
        [min]="5"
        [step]="5"
        [hasWarning]="form.controls.sizeOfArea.invalid && form.controls.sizeOfArea.touched"
        class="mt-xs block"
      />
      @if (form.controls.sizeOfArea.invalid && form.controls.sizeOfArea.touched) {
        <div class="error">{{ t('createJobRequest.lawnMowing.sizeOfArea.error') }}</div>
      }
    </div>
  </div>
</form>
